import debounce from "lodash/debounce";
import isUndefined from "lodash/isUndefined";
import { useMemo } from "react";
// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const useDebounce = (func, wait, 
// biome-ignore lint/suspicious/noExplicitAny: <explanation>
deps, options) => {
    const dependencyList = isUndefined(deps) ? [] : [...deps];
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    return useMemo(() => debounce(func, wait, options), [...dependencyList]);
};
//# sourceMappingURL=debounce.js.map